import { useContext, useMemo, useState, useEffect } from "react";

import { CardHomeStatus, CardHomeStatuItem } from "./styled";

import DashboardCardWrapper from "../Wrapper";
import {
  yearOptions,
  typePaycheckOptions,
  normalizeStrapiRegister,
} from "utils";
import { CoreContext } from "context/CoreContext";
import { parseCurrency } from "utils/parsers";

export default function DashboardCardHome({
  register,
  filterYear,
  setFilterYear,
  filterType,
  setFilterType,
  filterMonth,
  setFilterMonth,
}) {
  const { user } = useContext(CoreContext);
  const [availableMonthOptions, setAvailableMonthOptions] = useState([]);

  const isDataLoaded =
    register && register.holeriteResult && register.holeriteResult.length > 0;

  useEffect(() => {
    if (register) {
      const months = new Set();

      if (register?.holeriteMonthCounts) {
        register.holeriteMonthCounts.forEach((item, index) => {
          if (item[1] > 0) {
            const monthNumber = index + 1;
            months.add(monthNumber);
          }
        });
      }

      if (register?.employeeMonthCounts) {
        register.employeeMonthCounts.forEach(([_, count], index) => {
          if (count > 0) {
            const monthNumber = index + 1;
            months.add(monthNumber);
          }
        });
      }

      const monthOptions = Array.from(months)
        .sort((a, b) => a - b)
        .map((month) => ({
          id: String(month).padStart(2, "0"),
          title: new Date(filterYear, month - 1).toLocaleString("pt-BR", {
            month: "long",
          }),
        }));

      setAvailableMonthOptions(monthOptions);
    }
  }, [register, filterYear]);

  const proventos = isDataLoaded ? register.proventos || 0 : 0;
  const descontos = isDataLoaded
    ? register.descontoCounts?.reduce((acc, cur) => acc + cur[1], 0) || 0
    : 0;
  const liquido = isDataLoaded
    ? register.holeriteMonthCounts?.reduce((acc, cur) => acc + cur[1], 0) || 0
    : 0;

  const availableTypes = useMemo(() => {
    if (isDataLoaded) {
      const typesInRegister = [
        ...new Set(register.holeriteResult.map((item) => item.attributes.type)),
      ];
      return typePaycheckOptions.filter((option) =>
        typesInRegister.includes(option.id)
      );
    }
    return [];
  }, [isDataLoaded, register]);

  const cards = user?.isManager
    ? (register?.events?.data || [])
        .map((m) => {
          const reg = normalizeStrapiRegister(m);
          return reg?.totalVencimento > 0 || reg?.totalDesconto > 0
            ? {
                title: reg?.descricao,
                value:
                  reg?.totalDesconto > 0 ? (
                    <span style={{ color: "red" }}>{`${parseCurrency(
                      reg?.totalDesconto
                    )}`}</span>
                  ) : (
                    parseCurrency(reg?.totalVencimento)
                  ),
              }
            : null;
        })
        .filter(Boolean)
        .slice(0, 6) // Limita a exibição aos primeiros 6 itens
    : [
        { title: "Proventos", value: parseCurrency(proventos) },
        { title: "Descontos", value: parseCurrency(descontos) },
        { title: "Líquido", value: parseCurrency(liquido) },
      ];

  return (
    <>
      <DashboardCardWrapper
        title={user?.isManager ? "" : "Dashboard do Funcionário"}
        selectable={{
          options: yearOptions,
          placeholder: "Ano",
          value: filterYear,
          onChange: (value) => {
            setFilterYear(value);
            setFilterMonth(filterMonth);
          },
        }}
        selectableOptional={
          availableTypes.length > 0
            ? {
                options: availableTypes,
                placeholder: "Tipo",
                value: filterType,
                onChange: (value) => setFilterType(value),
              }
            : null
        }
        selectableMonth={{
          options: availableMonthOptions,
          placeholder: "Mês",
          value: filterMonth,
          onChange: (value) => setFilterMonth(value),
        }}
      >
        <CardHomeStatus>
          {cards.map((item, key) => (
            <CardHomeStatuItem key={key}>
              <b>{item.title}</b>
              <p>{item.value}</p>
            </CardHomeStatuItem>
          ))}
        </CardHomeStatus>
      </DashboardCardWrapper>
    </>
  );
}
